import { useEffect } from 'react';

export function useWavePainter(canvasRef, speaker, activity, micLevel) {
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    let raf = 0;
    let t = 0;

    function resize() {
      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      const width = canvas.clientWidth;
      const height = canvas.clientHeight;
      canvas.width = Math.floor(width * ratio);
      canvas.height = Math.floor(height * ratio);
      ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
    }

    resize();
    window.addEventListener('resize', resize);

    function draw() {
      t += 0.05;
      const w = canvas.clientWidth;
      const h = canvas.clientHeight;
      const baseY = h / 2;
      const bars = 68;
      const gap = 4;
      const barWidth = (w - gap * (bars - 1)) / bars;

      const baseColor = speaker === 'user' ? '#568ded' : speaker === 'sigmund' ? '#ffffff' : '#568ded';
      const glow =
        speaker === 'user'
          ? 'rgba(86,141,237,0.45)'
          : speaker === 'sigmund'
            ? 'rgba(255,255,255,0.45)'
            : 'rgba(86,141,237,0.25)';

      ctx.clearRect(0, 0, w, h);
      ctx.fillStyle = 'rgba(3, 17, 40, 0.55)';
      ctx.fillRect(0, 0, w, h);

      ctx.shadowBlur = 18;
      ctx.shadowColor = glow;
      ctx.fillStyle = baseColor;

      for (let i = 0; i < bars; i += 1) {
        const phase = t + i * 0.18;
        const pulse = (Math.sin(phase) + 1) / 2;
        const voiceBoost =
          speaker === 'user' ? micLevel * 95 : speaker === 'sigmund' ? 55 * (0.45 + pulse) : 10;
        const idleBoost = activity ? 24 : 8;
        const envelope = 1 - Math.abs(i - bars / 2) / (bars / 2);
        const height = Math.max(6, envelope * (idleBoost + voiceBoost));

        const x = i * (barWidth + gap);
        const y = baseY - height / 2;
        const r = 3;

        ctx.beginPath();
        ctx.moveTo(x + r, y);
        ctx.arcTo(x + barWidth, y, x + barWidth, y + height, r);
        ctx.arcTo(x + barWidth, y + height, x, y + height, r);
        ctx.arcTo(x, y + height, x, y, r);
        ctx.arcTo(x, y, x + barWidth, y, r);
        ctx.closePath();
        ctx.fill();
      }

      raf = requestAnimationFrame(draw);
    }

    raf = requestAnimationFrame(draw);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('resize', resize);
    };
  }, [canvasRef, speaker, activity, micLevel]);
}
